<template>
  <div class="authority-manage position-header">
    <navHeader :titleList="['代办事项']"/>
    <div class="rhBrand-content common-padding">
      <el-card class="box-card">
        <el-row :gutter="20">
          <el-col :span="5">
            <span class="search-text">一级：</span>
            <el-select v-model="type" placeholder="请选择" class="search-item" clearable @change="getSourceTypeList" size="small">
              <el-option
                  v-for="item in typeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="5">
            <span class="search-text">二级：</span>
            <el-select v-model="sourceType" placeholder="请选择" class="search-item" clearable @change="getItemList" size="small">
              <el-option
                  v-for="item in sourceTypeList"
                  :key="item.sourceId"
                  :label="item.sourceName"
                  :value="item.sourceId"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="5">
            <el-button @click="search" class="btn-search" round icon="el-icon-search" size="small">查询</el-button>
            <el-button @click="reset" type="warning" round icon="el-icon-refresh" size="small">重置</el-button>
          </el-col>
        </el-row>
      </el-card>
      <el-card class="box-card flex-1 table-card">
        <el-row class="common-margin flex-1 table-main">
          <el-table
              :data="tableData"
              style="width: 100%"
              border
              class="flex-1" stripe height="100%"
          >
            <el-table-column type="index" width="60px" fixed align="center"></el-table-column>
            <el-table-column label="时间" prop="createTime" align="center"></el-table-column>
            <el-table-column label="内容" prop="sourceName" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column label="状态" prop="isRead" align="center" show-overflow-tooltip>
              <template slot-scope="scope">
                {{ scope.row.isRead === '2' ? '已读' : '未读' }}
              </template>
            </el-table-column>
            <el-table-column width="100" align="center" label="操作" fixed="right">
              <template slot-scope="scope">
                <el-button
                    type="text"
                    size="mini"
                    icon="el-icon-document"
                    @click="checkDetail(scope.row.sourceId, scope.row.sourceType, scope.row.id)"
                >详情</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
              :current-page.sync="currentPage"
              :page-size="pageSize"
              layout="total, prev, pager, next, sizes"
              :total="total"
          >
          </el-pagination>
        </el-row>
      </el-card>
    </div>
  </div>
</template>

<script>
import navHeader from '../../components/navHeader'

export default {
  data () {
    return {
      title: '',
      type: '',
      typeList: [],
      sourceType: '',
      tableData: [],
      sourceTypeList: [],
      sourceId: '',
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  components: {
    navHeader
  },
  created () {
    this.getTypeList()
    this.getPageList()
  },
  methods: {
    async getTypeList () {
      let {data: res} = await this.$http.get('/pendingMatters/getSourceType')
      if (res.code === '200') {
        this.typeList = []
        for (let key in res.data) {
          this.typeList.push({
            label: res.data[key],
            value: key
          })
        }
      }
    },
    async getSourceTypeList (val) {
      this.sourceType = ''
      if (!val) {
        this.sourceTypeList = []
      } else {
        let {data: res} = await this.$http.get('/pendingMatters/getSourceListByType/' + val)
        if (res.code === '200') {
          this.sourceTypeList = res.data
        }
      }
    },
    getItemList (val) {
      this.sourceId = val
      // this.getPageList()
    },
    async getPageList () {
      let params = {
        sourceId: this.sourceId,
        currentPage: this.currentPage,
        pageSize: this.pageSize
      }
      let {data: res} = await this.$http.post(
        '/pendingMatters/getPageList',
        params
      )
      if (res.code === '200') {
        this.tableData = res.data.records
        this.total = parseInt(res.data.total)
      } else {
        this.$message.error(res.msg)
      }
    },
    search () {
      this.currentPage = 1
      this.getPageList()
    },
    reset () {
      this.type = ''
      this.sourceType = ''
      this.sourceId = ''
      this.pageSize = 10
      this.currentPage = 1
      this.getPageList()
    },
    checkDetail (id, type, itemId) {
      let name = ''
      switch (type) {
        case '1':
          name = 'RhDetail'
          break
        case '2':
          name = 'AddBrand'
          break
        case '3':
          name = 'MajorDetail'
          break
        case '4':
          name = 'AddMajorProduct'
          break
        case '6':
          name = 'AddFactory'
          break
        case '8':
          name = 'AddService'
          break
        case '9':
          name = 'home'
          break
        default:
          break
      }
      if (!name) return
      this.$router.push({
        name: name,
        params: {
          id,
          type: 'edit'
        }
      })
      this.$http.post('/pendingMatters/update', {id: itemId})
    },
    // 分页
    handleCurrentChange (page) {
      this.currentPage = page
      this.getPageList()
    },
    handleSizeChange (size) {
      this.pageSize = size
      this.getPageList()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/toDo/index.vue